"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatAddress = exports.formatAmount = void 0;
const formatAmount = (amount) => amount.toFixed(2).replace('.', ',') + ' €';
exports.formatAmount = formatAmount;
const formatAddress = (address) => {
    if (!address)
        return '';
    const line1 = [address.street, address.postalCode].filter(Boolean).join(', ');
    const line2 = [address.state, address.city, address.country]
        .filter(Boolean)
        .join(', ');
    return [line1, line2].filter(Boolean).join('\n'); // Salto de línea
};
exports.formatAddress = formatAddress;
